import {
  WAREHOUSE_SETUP_SELECT_DATABASE,
  WAREHOUSE_SETUP_SELECT_CONNECT_TAB,
  WAREHOUSE_SETUP_CONNECT,
  WAREHOUSE_SETUP_CONNECT_ERROR,
  WAREHOUSE_SETUP_CONNECTED,
  WAREHOUSE_SETUP_COMPLETED,
  WAREHOUSE_SETUP_CANCELED,
  WAREHOUSE_SETUP_CHANGE_STEP,
  CREATING_WAREHOUSE,
  CREATE_WAREHOUSE_ERROR,
  CREATED_WAREHOUSE
} from 'actions'

const initialState = {
  databaseId: '',
  currentStep: 'select',
  connectTab: 'existing',
  areSettingsValid: false,
  isConnecting: false,
  didConnect: false,
  didConnectionFail: false,
  error: null,
  isCreating: false,
  didCreate: false,
  didCreateFail: false,
  failedConnectionAttempts: 0,
  settings: {}
}

export default function(state = initialState, { type, payload }) {
  switch (type) {
    case WAREHOUSE_SETUP_SELECT_DATABASE:
      return {
        ...state,
        databaseId: payload
      }
    case WAREHOUSE_SETUP_SELECT_CONNECT_TAB:
      return {
        ...state,
        connectTab: payload
      }
    case WAREHOUSE_SETUP_CHANGE_STEP:
      return {
        ...state,
        currentStep: payload
      }

    case WAREHOUSE_SETUP_CONNECT:
      return {
        ...state,
        ...payload,
        isConnecting: true,
        didConnectionFail: false,
        didConnect: false
      }
    case WAREHOUSE_SETUP_CONNECT_ERROR:
      return {
        ...state,
        isConnecting: false,
        didConnectionFail: true,
        didConnect: false,
        error: payload,
        failedConnectionAttempts: state.failedConnectionAttempts + 1
      }
    case WAREHOUSE_SETUP_CONNECTED:
      return {
        ...state,
        isConnecting: false,
        didConnectionFail: false,
        didConnect: true
      }

    case WAREHOUSE_SETUP_CANCELED:
    case WAREHOUSE_SETUP_COMPLETED:
      return { ...initialState }

    case CREATING_WAREHOUSE:
      return {
        ...state,
        isCreating: true,
        didCreate: false,
        didCreateFail: false
      }
    case CREATE_WAREHOUSE_ERROR:
      return {
        ...state,
        isCreating: false,
        didCreate: false,
        didCreateFail: true,
        error: payload.error
      }
    case CREATED_WAREHOUSE:
      return {
        ...state,
        isCreating: false,
        didCreate: true,
        didCreateFail: false
      }
    default:
      return state
  }
}
